export default {
  usuarioId: {
    value: null,
    options: [],
    selectedList: []
  },
  periodoId: {
    value: null,
    options: [],
    selectedList: []
  }
}



// WEBPACK FOOTER //
// ./src/views/private/visitas/reports/deslocamento/search/search-form.js